// // add all script inside the polyfill file
// import './polyfill.js';
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import Vue from "vue";
import VueMq from "vue-mq";
import vSelect from "vue-select";
import { CollapsePlugin } from "bootstrap-vue";
import { ButtonPlugin } from "bootstrap-vue";
import "vue-select/dist/vue-select.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { BSpinner } from "bootstrap-vue";

// import {Spinner} from 'spin.js';

// var opts = {
//   lines: 13, // The number of lines to draw
//   length: 38, // The length of each line
//   width: 17, // The line thickness
//   radius: 45, // The radius of the inner circle
//   scale: 1, // Scales overall size of the spinner
//   corners: 1, // Corner roundness (0..1)
//   speed: 1, // Rounds per second
//   rotate: 0, // The rotation offset
//   animation: 'spinner-line-fade-quick', // The CSS animation name for the lines
//   direction: 1, // 1: clockwise, -1: counterclockwise
//   color: '#ffffff', // CSS color or array of colors
//   fadeColor: 'transparent', // CSS color or array of colors
//   top: '50%', // Top position relative to parent
//   left: '50%', // Left position relative to parent
//   shadow: '0 0 1px transparent', // Box-shadow for the lines
//   zIndex: 2000000000, // The z-index (defaults to 2e9)
//   className: 'spinner', // The CSS class to assign to the spinner
//   position: 'absolute', // Element positioning
// };

// // var target = document.getElementById('foo')
// var loadd = document.querySelector("foo")
// var spinner = new Spinner(opts).spin(loadd)

// Vue.use(CardPlugin)
Vue.use(CollapsePlugin);
Vue.use(ButtonPlugin);

// Vue.use(VueAwesomeSwiper)
Vue.use(VueMq, {
    breakpoints: {
        // default breakpoints - customize this
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: Infinity
    },
    defaultBreakpoint: "sm" // customize this for SSR
});
Vue.component("b-spinner", BSpinner);
Vue.mixin(require("./mixins/asset.js"));
Vue.component("v-select", vSelect);
Vue.component("search-service", require("./components/service/SearchService.vue").default);
Vue.component("result-model", require("./components/service/ResultModel.vue").default);
Vue.component("result-periodical", require("./components/service/ResultPeriodical.vue").default);
Vue.component("promotion", require("./components/service/Promotion.vue").default);
Vue.component("remark", require("./components/service/Remark.vue").default);

const app = new Vue({
    el: "#service-periodical",

    data() {
        return {
            dataHead: null,
            popupOpen: false,
            dataTableservices: null,
            idModel: null,
            idEngine: null,
            idDistance: null,
            nameModel: null,
            nameEngine: null,
            timechk: null,
            distanceSelect: null
        };
    },
    mounted() {
        // document.body.scrollTop = document.documentElement.scrollTop = 200
        this.loadIconDrag();
    },

    computed: {
        // videoSource() {
        //     let source
        //     if (this.$mq === 'xs' || this.$mq === 'sm') source = window.videoMobile
        //     else source = window.videoDesktop
        //     return source
        // }
    },

    methods: {
        loadIconDrag() {
            var container = document.querySelector(".icon-drag-show");
            lottie.loadAnimation({
                container: container, // the dom element that will contain the animation
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: "/images/click-drag.json" // the path to the animation json
            });
        },
        setfc(idmodelservice, idengineservice, iddistance, year, namemodel, nameengine) {
            this.idModel = idmodelservice;
            this.idEngine = idengineservice;
            this.idDistance = iddistance;
            this.year = year;
            this.nameModel = namemodel;
            this.nameEngine = nameengine;
        },
        get4DecimalPointsWithCommas(amount) {
            return amount.toLocaleString(undefined, { maximumFractionDigits: 4, minimumFractionDicits: 4 });
        },
        chkText_comma(value) {
            // return (typeof value== 'number' && value%1== 0);
            if (value == null) {
                value = "-";
            } else if (isNaN(value)) {
                value = value;
            } else {
                let decimals = 2;
                let decpoint = "."; // Or Number(0.1).toLocaleString().substring(1, 2)
                let thousand = ","; // Or Number(10000).toLocaleString().substring(2, 3)

                let n = Math.abs(value)
                    .toFixed(decimals)
                    .split(".");
                n[0] = n[0]
                    .split("")
                    .reverse()
                    .map((c, i, a) => (i > 0 && i < a.length && i % 3 == 0 ? c + thousand : c))
                    .reverse()
                    .join("");
                let final = (Math.sign(value) < 0 ? "-" : "") + n.join(decpoint);
                value = final;
            }

            return value;
        },
        chkBR(value) {
            if (value && value !== "") {
                return value.replace(/\n/g, "<br />");
            }
        },
        chkText(value) {
            // return (typeof value== 'number' && value%1== 0);
            const regex = /{Merge=([0-9]+)}(.+)/;
            const regex2 = /^\s*$/gm;
            const str = value;
            let m;
            let valuetext = value;

            if ((m = regex.exec(str)) !== null) {
                valuetext = m[2];
            }
            if (valuetext == null) {
                //เชคถ้าเป็นข้อมูล null มาก็จะโชว์ข้อความ -
                valuetext = "-";
            } else if (isNaN(value)) {
                //เชคถ้าเป็นข้อมูล text มาก็จะโชว์ข้อความนั้น
                valuetext = valuetext;
            } else {
                // ถ้าเป็นตัวเลขจะใส่ comma and ทศนิยม
                valuetext = Number(valuetext).toLocaleString();

                //เชคให้ใส่ ทศนิยม
                // if(regex2.exec(valuetext)!==null){
                //   valuetext="";
                // }else{
                //   valuetext = Number(valuetext)
                //   if(Number.isInteger(valuetext)==false){
                //     valuetext = this.formatCurrency(valuetext);
                //   }else{
                //     valuetext = Number(valuetext).toLocaleString();
                //   }
                // }
            }

            return valuetext;
        },
        chkTextSum(value) {
            // return (typeof value== 'number' && value%1== 0);
            const regex = /{Merge=([0-9]+)}(.+)/;
            const regex2 = /^\s*$/gm;
            const str = value;
            let m;
            let valuetext = value;

            if ((m = regex.exec(str)) !== null) {
                valuetext = m[2];
            }
            if (valuetext == null) {
                //เชคถ้าเป็นข้อมูล null มาก็จะโชว์ข้อความ -
                valuetext = "-";
            } else if (isNaN(value)) {
                //เชคถ้าเป็นข้อมูล text มาก็จะโชว์ข้อความนั้น
                valuetext = valuetext;
            } else {
                // ถ้าเป็นตัวเลขจะใส่ comma and ทศนิยม
                valuetext = Number(valuetext);
                if (Number.isInteger(valuetext) == false) {
                    valuetext = this.formatCurrency(valuetext);
                } else {
                    valuetext = Number(valuetext).toLocaleString();
                }
            }
            valuetext = this.formatCurrency(value);

            return valuetext;
        },
        formatCurrency(number) {
            number = parseFloat(number);
            return number.toFixed(2).replace(/./g, function(c, i, a) {
                return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
            });
        },
        chkcolspan(value) {
            const regex = /{Merge=([0-9]+)}(.+)/;
            const str = value;
            let m;
            let colspan = 1;

            if ((m = regex.exec(str)) !== null) {
                colspan = m[1];
            }

            return colspan;
        },
        myTimer() {
            let element = document.querySelector("#result-model-show");
            let hearder_height = document.querySelector(".header-wrapper");
            let get_height_headerbar = hearder_height.getBoundingClientRect().height;

            if (element != null) {
                clearInterval(this.timechk);
                window.scroll({
                    top: element.offsetTop - get_height_headerbar, // could be negative value
                    left: 0,
                    behavior: "smooth"
                });
            }
        },
        scrollIntoTop() {
            this.timechk = setInterval(this.myTimer, 600);
        },
        scrollToShowModel() {
            // var element = document.getElementById('select-model');
            var element = document.getElementById("service-periodical");
            if (element != null) {
                element.scrollIntoView({
                    behavior: "smooth"
                    // block: 'center',
                });
            }
        },
        scrollToShowYear() {
            // var element = document.getElementById('collapse-1');
            var element = document.getElementById("select-model");
            if (element != null) {
                element.scrollIntoView({
                    behavior: "smooth"
                    // block: 'center',
                });
            }
        },
        scrollToShowEngine() {
            // var element = document.getElementById('collapse-2');
            // var element = document.getElementById('select-year');
            // var element = document.getElementById('select-engine');

            // if(element!=null){
            //     element.scrollIntoView({
            //       behavior: 'smooth',
            //       // block: 'center',
            //     });
            // }
            let element = document.querySelector("#collapse-3");
            let hearder_height = document.querySelector(".header-wrapper");
            let get_height_headerbar = hearder_height.getBoundingClientRect().height;
            let y = element.getBoundingClientRect().top + window.pageYOffset - 140;
            if (element != null) {
                window.scroll({
                    top: y,
                    behavior: "smooth"
                });
            }
        },
        scrollName(value) {
            let element = document.querySelector(value);
            let hearder_height = document.querySelector(".header-wrapper");
            let get_height_headerbar = hearder_height.getBoundingClientRect().height;
            document.body.scrollTop = document.documentElement.scrollTop = element.offsetTop - get_height_headerbar;
            // window.scroll({
            //   top: element.offsetTop-get_height_headerbar, // could be negative value
            //   left: 0,
            //   behavior: 'smooth'
            // });
        },
        scrollToShowDistance() {
            // var element = document.getElementById('select-engine');
            // if(element!=null){
            //     element.scrollIntoView({
            //       behavior: 'smooth',
            //       // block: 'center',
            //     });
            // }
        },
        updateGuideline() {
            document.getElementById("guideline").style.transition = "none";
            // setTimeout(() => {
            var contentOffsetHeight = document.getElementById("content").offsetHeight;
            var guidelineHeight = contentOffsetHeight - 80;
            maxY = guidelineHeight - 70;
            document.getElementById("guideline").style.height = guidelineHeight + "px";
            //  }, 200);
        },
        initPeriodicalTableScroll() {
            $(".main-table-service-periodical")
                .clone(true)
                .appendTo("#service-periodical-tbl-fixedscroll")
                .addClass("clone");
        }
    }
});



// WEBPACK FOOTER //
// ./resources/js/service.js